(function () {
  function initImageModal($) {
    var modalOverlay = null;
    var modalContainer = null;
    var modalMain = null;
    var modalThumbnails = null;
    var currentImages = [];
    var currentIndex = 0;
    var isModalCreated = false;

    function createModal() {
      if (isModalCreated) return;

      var modalHTML = `
        <div class="dtc-image-modal-overlay" id="dtc-image-modal">
          <div class="dtc-image-modal-container">
            <button class="dtc-image-modal-close" aria-label="Close modal">
              <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 2L14 14M2 14L14 2" stroke="white" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
            <div class="dtc-image-modal-main">
              <div class="dtc-image-modal-main-inner">
                <img src="" alt="" data-modal-main-image>
                <div class="dtc-image-modal-loading" style="display: none;"></div>
              </div>
            </div>
            <button class="dtc-image-modal-nav is--prev" aria-label="Previous image" data-modal-prev>
              <svg viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 1L1 8L7 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button class="dtc-image-modal-nav is--next" aria-label="Next image" data-modal-next>
              <svg viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L7 8L1 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div class="dtc-image-modal-thumbnails-wrapper">
              <div class="dtc-image-modal-thumbnails" data-modal-thumbnails></div>
            </div>
          </div>
        </div>
      `;

      $('body').append(modalHTML);

      modalOverlay = $('#dtc-image-modal');
      modalContainer = modalOverlay.find('.dtc-image-modal-container');
      modalMain = modalOverlay.find('.dtc-image-modal-main');
      modalThumbnails = modalOverlay.find('[data-modal-thumbnails]');

      isModalCreated = true;
    }

    function openModal(images, startIndex) {
      if (!isModalCreated) createModal();

      currentImages = images;
      currentIndex = startIndex || 0;

      renderThumbnails();
      updateMainImage();

      modalOverlay.addClass('is--active');
      $('body').addClass('is--modal-open');

      updateNavigationButtons();
    }

    function closeModal() {
      modalOverlay.removeClass('is--active');
      $('body').removeClass('is--modal-open');
    }

    function renderThumbnails() {
      modalThumbnails.empty();

      currentImages.forEach(function (image, index) {
        var thumbHTML = `
          <div class="dtc-image-modal-thumb ${index === currentIndex ? 'is--selected' : ''}" data-modal-thumb-index="${index}">
            <img src="${image.thumb || image.src}" alt="${image.alt || ''}" loading="lazy">
          </div>
        `;
        modalThumbnails.append(thumbHTML);
      });
    }

    function updateMainImage() {
      var image = currentImages[currentIndex];
      if (!image) return;

      var $mainImg = modalMain.find('img');
      var $loading = modalMain.find('.dtc-image-modal-loading');

      $loading.show();

      $mainImg.attr('src', image.src);
      $mainImg.attr('alt', image.alt || '');

      $mainImg.on('load', function () {
        $loading.hide();
      });

      $mainImg.on('error', function () {
        $loading.hide();
      });

      if ($mainImg[0].complete) {
        $loading.hide();
      }

      modalThumbnails.find('.dtc-image-modal-thumb').removeClass('is--selected');
      modalThumbnails.find('[data-modal-thumb-index="' + currentIndex + '"]').addClass('is--selected');

      updateNavigationButtons();
    }

    function updateNavigationButtons() {
      var $prevBtn = modalContainer.find('[data-modal-prev]');
      var $nextBtn = modalContainer.find('[data-modal-next]');

      if (currentImages.length <= 1) {
        $prevBtn.hide();
        $nextBtn.hide();
      } else {
        $prevBtn.show();
        $nextBtn.show();
      }
    }

    function goToPrevImage() {
      if (currentImages.length <= 1) return;

      currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
      updateMainImage();
    }

    function goToNextImage() {
      if (currentImages.length <= 1) return;

      currentIndex = (currentIndex + 1) % currentImages.length;
      updateMainImage();
    }

    function goToImage(index) {
      if (index < 0 || index >= currentImages.length) return;

      currentIndex = index;
      updateMainImage();
    }

    function collectProductImages($productMedia) {
      var images = [];

      $productMedia.find('[data-media-type="image"]').each(function (index) {
        var $item = $(this);
        var $img = $item.find('img');

        if ($img.length) {
          var masterUrl = $img.attr('data-master');

          if (!masterUrl || masterUrl.includes('data:image') || masterUrl.includes('img_svg')) {
            return;
          }

          var baseUrl = masterUrl.split('?')[0];

          var srcUrl = baseUrl + '?width=1200';
          var thumbUrlFinal = baseUrl + '?width=200';

          images.push({
            src: srcUrl,
            thumb: thumbUrlFinal,
            alt: $img.attr('alt') || '',
            index: index
          });
        }
      });

      return images;
    }

    $(document).on('click', '[data-t4s-gallery--open]', function (e) {
      var $clickedItem = $(this).closest('[data-media-type="image"]');
      var $productMedia = $clickedItem.closest('[data-product-single-media-group]');

      if ($productMedia.length === 0) {
        $productMedia = $clickedItem.closest('.t4s-product__media-wrapper');
      }

      if ($productMedia.length === 0) return;

      var images = collectProductImages($productMedia);

      if (images.length === 0) return;

      var clickedIndex = 0;
      $productMedia.find('[data-media-type="image"]').each(function (index) {
        if ($(this).is($clickedItem)) {
          clickedIndex = index;
        }
      });

      openModal(images, clickedIndex);
    });

    $(document).on('click', '.dtc-image-modal-close', function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeModal();
    });

    $(document).on('click', '.dtc-image-modal-overlay', function (e) {
      if ($(e.target).is('.dtc-image-modal-overlay')) {
        closeModal();
      }
    });

    $(document).on('click', '[data-modal-prev]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      goToPrevImage();
    });

    $(document).on('click', '[data-modal-next]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      goToNextImage();
    });

    $(document).on('click', '[data-modal-thumb-index]', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var index = parseInt($(this).attr('data-modal-thumb-index'));
      goToImage(index);
    });

    $(document).on('keydown', function (e) {
      if (!modalOverlay || !modalOverlay.hasClass('is--active')) return;

      if (e.key === 'Escape') {
        closeModal();
      } else if (e.key === 'ArrowLeft') {
        goToPrevImage();
      } else if (e.key === 'ArrowRight') {
        goToNextImage();
      }
    });

    $(document).on('touchstart', '.dtc-image-modal-main', function (e) {
      if (currentImages.length <= 1) return;

      var touch = e.originalEvent.touches[0];
      var startX = touch.clientX;

      $(this).on('touchend', function (e) {
        var touch = e.originalEvent.changedTouches[0];
        var endX = touch.clientX;
        var diffX = startX - endX;

        if (Math.abs(diffX) > 50) {
          if (diffX > 0) {
            goToNextImage();
          } else {
            goToPrevImage();
          }
        }

        $(this).off('touchend');
      });
    });
  }

  function initWhenReady() {
    if (typeof jQuery_T4NT !== 'undefined') {
      jQuery_T4NT(document).ready(function ($) {
        initImageModal($);
      });
    } else if (typeof jQuery !== 'undefined') {
      jQuery(document).ready(function ($) {
        initImageModal($);
      });
    } else {
      setTimeout(initWhenReady, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }
})();